export default "<section class=\"content-container\">\n  <div [innerHTML]=\"safePage\">\n  </div>\n</section>";